const pattern = /url\("(.+)"\)/;

export default pattern;